module.exports = __webpack_public_path__ + "static/media/f_man.f4a9f50e.png";